/**
 * Globale "Benötigt"-Badge-Utility.
 * Erscheint unten rechts (wie Toasts), gelb = Hinweis.
 * Nutzt dasselbe Positionierungs-System wie utils/toast.ts.
 */
import { showToast } from './toast.js';

export function showRequiredBadge(msg: string): void {
  showToast(msg, 'info');
}

export function clearRequiredBadges(): void {
  // Keine persistenten Badges mehr — Toasts verschwinden selbst nach 3s
}
